import { Layout } from "../../UI/Layout/Layout.tsx";
import { NavBar } from "../../UI/Layout/NavBar.tsx";
import { Footer } from "../../UI/Layout/Footer.tsx";
import { FullPageLoading } from "../../UI/FullPageLoading.tsx";
import { PrimaryButton } from "@normasteaching/norma-ui";
import { Plus } from "lucide-react";
import { useNavigate } from "react-router";
import { AdminMainContainer } from "../../UI/Admin/AdminMainContainer.tsx";
import { useAllNormasTeachingCoupons } from "../../ProductService/NormasTeachingCoupon/useAllNormasTeachingCoupons.ts";
import { CreateNormasTeachingCouponScreenPath } from "./CreateNormasTeachingCouponScreen.tsx";
import { AdminNormasTeachingCouponTable } from "./AdminNormasTeachingCouponTable.tsx";

export const AdminAllNormasTeachingCouponScreenPath =
  "/admin/normasteaching/all-coupons";
export function AdminAllNormasTeachingCouponScreen() {
  const { coupons, isLoading } = useAllNormasTeachingCoupons();
  const navigate = useNavigate();
  if (isLoading) return <FullPageLoading />;
  return (
    <Layout>
      <AdminMainContainer>
        <NavBar showAdminSideBarHandle />
        <div className={"flex-1 p-4 flex flex-col gap-4"}>
          <div
            className={
              "flex items-center justify-between gap-2 md:flex-row flex-col"
            }
          >
            <h1 className={"font-bold text-3xl flex-1"}>
              Coupons Norma's Teaching
            </h1>
            <div>
              <PrimaryButton
                iconRight={<Plus className={"w-5"} />}
                label={"Nuovo coupon"}
                onClick={() => navigate(CreateNormasTeachingCouponScreenPath)}
              />
            </div>
          </div>
          <div className={"overflow-x-auto"}>
            <AdminNormasTeachingCouponTable coupons={coupons} />
          </div>
        </div>
      </AdminMainContainer>

      <Footer />
    </Layout>
  );
}
